export const InterceptorSkipHeader = 'X-Skip-Interceptor';
export const AuthLocalStorageName = 'Auth';
